<template>
  <header class="blog-header">
    <div v-if="screenWidth < 768" class="blog-header-menu" @click="isOpenMobileMenu = true">
      <svg class="blog-header-menu__burger"><use xlink:href="#svg-blog-burger"></use></svg>
    </div>
    <a :href="blogDir" class="blog-header-logo">
      <svg class="blog-header-logo__icon"><use xlink:href="#svg-blog-logo"></use></svg>
    </a>
    <BlogSearch />
    <BlogGoToSite v-if="screenWidth >= 768" />
    <BlogMenu v-if="screenWidth >= 768" />
    <BlogLang v-if="screenWidth >= 768" />
    <BlogMobileMenu
      v-if="screenWidth < 768"
      :active="isOpenMobileMenu"
      @close="isOpenMobileMenu = false"
    />
    <DefDarkenBackground v-if="isOpenMobileMenu" @close="isOpenMobileMenu = false" />
  </header>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import BlogSearch from '@components/Blog/Header/BlogSearch.vue';
import BlogGoToSite from '@components/Blog/Header/BlogGoToSite.vue';
import BlogMenu from '@components/Blog/Header/BlogMenu.vue';
import BlogLang from '@components/Blog/Header/BlogLang.vue';
import BlogMobileMenu from '@components/Blog/Header/BlogMobileMenu.vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { ref, computed } from 'vue';

const isOpenMobileMenu = ref(false);
const screenWidth = useScreenWidth();
const resultsStore = useResultsStore();

const blogDir = computed(() => resultsStore.siteLanguages?.blogDir);
</script>

<style lang="scss" scoped>
.blog-header {
  display: grid;
  grid-template-columns: 20px 35px 20px;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  grid-template-areas: 'mobile-menu logo search';
  @include point-md {
    grid-template-columns: 60px 1fr 152px;
    grid-template-areas:
      'logo search goto'
      'logo menu lang';
    grid-gap: 24px 32px;
    justify-content: unset;
    height: 128px;
  }
  @include point-lg {
    grid-gap: 24px 40px;
  }
}
.blog-header-logo {
  display: block;
  grid-area: logo;
  &__icon {
    width: 35px;
    height: 56px;
    @include point-md {
      display: block;
      width: 60px;
      height: 96px;
    }
  }
}
.blog-header-menu {
  grid-area: mobile-menu;
  &__burger {
    fill: var(--background-black);
    width: 20px;
    height: 20px;
  }
}
</style>
